import { render } from "./BasicProductionTreeCropExpPackages.vue?vue&type=template&id=4b197096"
import script from "./BasicProductionTreeCropExpPackages.vue?vue&type=script&lang=js"
export * from "./BasicProductionTreeCropExpPackages.vue?vue&type=script&lang=js"

import exportComponent from "/home/noe/Dev/atc/agrotecchain_vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__